import { limitesDoDia } from '@sheafyield/dominio';

const DIA_MS = 86_400_000;

/**
 * A posição de um dia no calendário local, sem carregar a duração dele.
 *
 * A fonte do recorte é `limitesDoDia`, a mesma das consultas (ADR-0003). A
 * reconstrução em UTC transforma ano, mês e dia locais numa régua em que
 * dias vizinhos distam sempre uma unidade: no horário de verão, as
 * meia-noites reais podem distar 23 h ou 25 h e não servem para essa conta.
 */
function indiceDoDia(quando: Date): number {
  const inicioLocal = new Date(limitesDoDia(quando).de);
  return (
    Date.UTC(
      inicioLocal.getFullYear(),
      inicioLocal.getMonth(),
      inicioLocal.getDate(),
    ) / DIA_MS
  );
}

/**
 * Resume um instante como distância no calendário local: `"hoje"`,
 * `"ontem"`, `"há 3 dias"`, `"há 2 semanas"` ou `"há 2 meses"`.
 *
 * A lista precisa da distância civil, não de blocos de 24 horas: uma visita
 * das 22h de ontem continua sendo ontem às 8h de hoje. Depois de duas
 * semanas, o texto troca para semanas; ao completar 60 dias, para meses.
 *
 * Data ilegível não ganha uma contagem inventada e produz texto vazio.
 */
export function haQuantoTempo(iso: string, agora: Date = new Date()): string {
  const quando = new Date(iso);
  if (Number.isNaN(quando.getTime())) return '';

  const dias = indiceDoDia(agora) - indiceDoDia(quando);
  if (dias <= 0) return 'hoje';
  if (dias === 1) return 'ontem';
  if (dias < 14) return `há ${String(dias)} dias`;
  if (dias < 60) return `há ${String(Math.floor(dias / 7))} semanas`;

  const meses = Math.floor(dias / 30);
  return `há ${String(meses)} meses`;
}
